import React, {PureComponent} from 'react';
import {Select} from 'antd';
// import { message } from 'antd/lib/index';
import fetchHandler from '../../fetch/fetchHandler';
// import { updateFrameStatus } from '../../fetch/fetchApi';
const Option = Select.Option;
const AsyncRelationSelect = (ParentCom) => {
	return class extends PureComponent {
		constructor(props) {
			super(props);
			this.props = props;
			this.state={
				selectDisabled:false,
				NewOptions:[]
				// items:[this.parentItem.bind(this),this.parentItem2.bind(this),this.childernItem.bind(this)]
			}
			this.NewOptions=[];
		}
		// 自定义通用form（input关联）hoc
		//queryParam为请求selectOptions的参数，主控制组件
	              //('请选择项目',projectOptions,'project','logstorename','asyncOptions',alilogStore)
		parentItem (placeholder,optionsArray,ownName,paramName,paramValue,apiName,mapText,mapValue) {
			const hoc = this;
			const parentItem = class extends PureComponent {
				state = {
					NewOptions:[]
				}
				handleProvinceChange = (value) => {
					this.setState({
						[ownName]: value,
					});
					fetchHandler(apiName,{[ownName]:value}).then((res) => {
						if (res && res.code === 'success') {
							if(mapText&&mapValue){//如果配置了对应的数据字段名,例如：返回数据为[name:'小王']，则入参mapText值为name,mapValue的值为小王
								this.NewOptions=res.data.map((item, i) => {
									return {text:item[mapText],value:item[mapValue]}
								})
							}else{//否则取本身，例如：['hello','word']
								this.NewOptions=res.data.map((item, i) => {
									return {text:item,value:item}
								})
							}
							this.setState({
								NewOptions:this.NewOptions
							})
						}
					});
					//改变自身的值，控制的显示
					// hoc.ctx.props.form.setFieldsValue({[ownName]: value});
				}
				
				onSecondCityChange = (value) => {
					this.setState({
						[paramName]: value,
					});
					//改变自身的值，控制的显示
					hoc.ctx.props.form.setFieldsValue({[ownName]: `${this.state[ownName]},${value}`});
				}
				render () {
					const props = this.props;
					console.log(...props)
						return <div>
							<Select
								style={{ width: 80 }}
								value={this.state[ownName]}
								onChange={this.handleProvinceChange}
							>
								{optionsArray.map((op)=>{
									return <Option key={op.text} value={op.value} >{op.text}</Option>
								}) }
							</Select>
							<div className={"ant-form-item-label"}>
								<label className="ant-form-item-required">日志级别</label>
								<Select
									style={{ width: 80 }}
									value={this.state[paramName]}
									onChange={this.onSecondCityChange}
								>
									{this.state.NewOptions.map((op)=>{
										return <Option key={op.text} value={op.value} >{op.text}</Option>
									}) }
								</Select>
							</div>
						</div>
				}
			};
			return parentItem;
		}
		//受控组件1
		parentItem2 (placeholder,optionsArray,ownName,paramName,paramValue,disabled) {
			const hoc = this;
			const parentItem = class extends PureComponent {
				render () {
					const props = this.props;
					return <Select placeholder={placeholder} {...props}
								   onChange={(e) => {hoc.changeSelect.bind(hoc)(e, ownName,paramName,paramValue)}}>
						{optionsArray.map((op)=>{
							return <Option key={op.text} value={op.value} >{op.text}</Option>
						})
						}
					</Select>;
				}
			};
			return parentItem;
		}
		//受控组件2
		childItem (placeholder,optionsArray,ownName,paramName,paramValue,disabled) {
			let newArrayoptions=(optionsArray==='asyncOptions')?this.state.NewOptions:optionsArray;
			console.log(newArrayoptions)
			const hoc = this;
			const parentItem = class extends PureComponent {
				render () {
					const props = this.props;
					return <Select placeholder={placeholder} {...props}
								   onChange={(e) => {hoc.changeSelect.bind(hoc)(e, ownName,paramName,paramValue)}}>
						{newArrayoptions.map((op)=>{
							return <Option key={op.text} value={op.value} >{op.text}</Option>
						})
						}
					</Select>;
				}
			};
			return parentItem;
		}

		// select切换控制显示
		changeSelect(e,ownName, paramName,paramValue,apiName,mapText,mapValue) {
			console.log('ownName',ownName, ', paramName,',paramName,'paramValue',paramValue)
			const field = {};
			field[ownName] = e;
			// 操作formCore实例
			//改变自身的值，控制的显示
			this.ctx.props.form.setFieldsValue(field);
			this.ctx.visibleChange.bind(this.ctx)(e, ownName);
			if(paramValue==='asyncOptions'){//如果参数值是asyncOptions，表示通过接口请求为paramName下拉框的options
				fetchHandler(apiName,field).then((res) => {
					if (res && res.code === 'success') {
						if(mapText&&mapValue){//如果配置了对应的数据字段名,例如：返回数据为[name:'小王']，则入参mapText值为name,mapValue的值为小王
							this.NewOptions=res.data.map((item, i) => {
								return {text:item[mapText],value:item[mapValue]}
							})
						}else{//否则取本身，例如：['hello','word']
							this.NewOptions=res.data.map((item, i) => {
								return {text:item,value:item}
							})
						}
						this.setState({
							NewOptions:this.NewOptions
						})
						// this.childItem('',this.NewOptions,paramName);
						//
						// console.log(this.NewOptions)
					}
				});
				
			}
			if(paramName&&paramValue!=='asyncOptions'){//否则便是直接修改paramName的选中值为paramValue
				//改变其他组件的值
				this.ctx.props.form.setFieldsValue({[paramName]:paramValue});
				//改变由其他组件控制的显示
				this.ctx.visibleChange.bind(this.ctx)(paramValue, paramName);
			}
		}
		componentDidMount(){
			if (this.props.getInstance&&typeof this.props.getInstance === 'function') {
				this.props.getInstance(this.ctx);
			}
		}
		render() {
			const items = [this.parentItem.bind(this),this.parentItem2.bind(this),this.childItem.bind(this)];
			// getInstance 获取子组件上下文
			return <ParentCom {...this.props} relationSelect={items}  getInstance={(ctx) => {this.ctx = ctx}}/>;
		}
	};
}

export default AsyncRelationSelect;


// WEBPACK FOOTER //
// ./src/AntD/hoc/form/asyncRelationSelect.js